import React from 'react';
import './Footer.css';

const Footer = () => {
  const phoneNumber = '0905286898';
  const lineId = '@703rvibx';
  const lineUrl = 'https://line.me/R/ti/p/@703rvibx';

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">聯絡資訊</h3>
          <div className="contact-info">
            <p>
              <strong>LINE ID：</strong>
              <a
                href={lineUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
                aria-label="加 LINE 聯絡"
              >
                {lineId}
              </a>
            </p>
            <p>
              <strong>聯繫聯絡電話：</strong>
              <a
                href={`tel:${phoneNumber}`}
                className="contact-link"
                aria-label="撥打電話"
              >
                {phoneNumber}
              </a>
            </p>
          </div>
        </div>
        
        <div className="footer-section">
          <h3 className="footer-title">服務項目</h3>
          <p>家庭搬家、學生套房搬家、公司行號搬遷、自助搬家、廢棄物清運</p>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">服務地區</h3>
          <p>全省服務｜北中南各縣市皆可安排到府</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>Copyright © 2025 威特嘉精緻搬家</p>
      </div>
    </footer>
  );
};

export default Footer;

